import React, { useState } from 'react'
import { Card, Button } from 'react-bootstrap'
import ScaleComponent from './five-star'
import Feedback from './feedback'
import { get } from 'lodash'
import useUserCourseRatingMutation from '../../../hooks/use-user-course-rating-mutation'
import SpinnerButton from '../../common/spinner-button'
import useToasts from '../../../hooks/use-toasts'

const CoursePrompt = ({
    userRating = {},
    userId,
}) => {
    const [ feedback, setFeedback ] = useState()
    const [ rating, setRating ] = useState(userRating.rating)
    const {
        success: toastSuccess,
        error: toastError,
    } = useToasts({
        successMessage: 'Thank you!',
        errorMessage: 'Error submitting feedback.'
    })
    const {
        updateCourseRating,
        isUpdating,
    } = useUserCourseRatingMutation({
        userId,
        ratingId: userRating.id,
        feedback,
        rating,
        onSuccess: toastSuccess,
        onError: toastError,
    })

    const renderFeedback = () => {
        if (!rating) {
            return null
        }
        return (
            <React.Fragment>
                <Feedback
                    value={feedback}
                    onChange={setFeedback}
                />
                <SpinnerButton
                    onClick={() => updateCourseRating()}
                    busy={isUpdating}
                >
                    Submit Feedback
                </SpinnerButton>
            </React.Fragment>
        )
    }

    const courseName = get(userRating, 'courseToRate.name', '')

    return (
        <React.Fragment>
            <div>How was {courseName}?</div>
            <div><ScaleComponent value={rating} onChange={setRating} /></div>
            {renderFeedback()}
        </React.Fragment>
    )
}

export default CoursePrompt